import React from "react";
import { Table, Card, Badge } from "react-bootstrap";
import { FaBook } from "react-icons/fa";

function CourseList() {
  const bookings = [
    {
      id: "Legal Reasoning",
      course: "Lw-205",
      date: "2023-11-15",
      amount: "₹2500",
      status: "Paid",
    },
    {
      id: "Law Basics",
      course: "Lw-306",
      date: "2023-11-18",
      amount: "₹1850",
      status: "Pending",
    },
    {
      id: "Legal Advance",
      course: "Lw-112",
      date: "2023-11-20",
      amount: "₹3200",
      status: "Paid",
    },
    {
      id: "Clat latest",
      course: "Lw-409",
      date: "2023-11-22",
      amount: "₹1570",
      status: "Overdue",
    },
  ];

  const getStatusBadge = (status) => {
    switch (status) {
      case "Paid":
        return (
          <Badge bg="success" className="w-100">
            Paid
          </Badge>
        );
      case "Pending":
        return (
          <Badge bg="warning" className="w-100" text="dark">
            Pending
          </Badge>
        );
      case "Overdue":
        return (
          <Badge bg="danger" className="w-100">
            Overdue
          </Badge>
        );
      default:
        return (
          <Badge bg="secondary" className="w-100">
            {status}
          </Badge>
        );
    }
  };
  return (
    <Card className="shadow border-0">
      <Card.Header className="bg-primary text-white">
        <FaBook className="me-2" />
        Transaction
      </Card.Header>
      <Card.Body>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Course Name</th>
              <th>Course ID</th>
              <th>Date</th>
              <th>Amount</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {bookings.map((booking) => (
              <tr key={booking.id}>
                <td>{booking.id}</td>
                <td>{booking.course}</td>
                <td>{booking.date}</td>
                <td>
                  <strong>{booking.amount}</strong>
                </td>
                <td>{getStatusBadge(booking.status)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
}

export default CourseList;
